const getOrdinal = (n) => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return s[(v - 20) % 10] || s[v] || s[0];
};

export const formatAsOfDate = (value) => {
  if (!value) return "—";

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;

  const day = parsed.getDate();
  const ordinalDay = `${day}${getOrdinal(day)}`;

  const monthYear = new Intl.DateTimeFormat(undefined, {
    month: "long",
    year: "numeric",
  }).format(parsed);
  
  return `${monthYear.replace(/\d{4}$/, "")}${ordinalDay}, ${parsed.getFullYear()}`;
};

const getReportAsOfDate = (report) => report?.effective_date || null;

const getReportUpdatedDate = (report) => report?.updated_date || null;

const getLatestReportDate = (reports = []) => {
  let latest = null;
  let fallback = null;
  reports.forEach((report) => {
    const raw = getReportAsOfDate(report);
    if (!raw) return;
    const parsed = new Date(raw);
    if (!Number.isNaN(parsed.getTime())) {
      if (!latest || parsed > latest) {
        latest = parsed;
      }
    } else if (!fallback) {
      fallback = raw;
    }
  });
  return latest ? latest.toISOString() : fallback;
};

const getLatestUpdatedDate = (reports = []) => {
  let latest = null;
  let fallback = null;
  reports.forEach((report) => {
    const raw = getReportUpdatedDate(report);
    if (!raw) return;
    const parsed = new Date(raw);
    if (!Number.isNaN(parsed.getTime())) {
      if (!latest || parsed > latest) {
        latest = parsed;
      }
    } else if (!fallback) {
      fallback = raw;
    }
  });
  return latest ? latest.toISOString() : fallback;
};

export const getResourceAsOfDate = (resource) => {
  if (!resource) return null;
  const direct = getReportAsOfDate(
    resource.latest_resource_report ||
      resource.latest_report ||
      resource.latest_resource_estimate ||
      resource.latest_resource_estimate_report ||
      resource.production_report ||
      resource.latest_production_report
  );
  if (direct) return direct;
  return getLatestUpdatedDate(
    resource.resource_reports ||
      resource.reports ||
      resource.resource_estimates ||
      resource.resource_estimate_reports ||
      resource.production_reports ||
      []
  );
};

export const getResourceLastUpdatedDate = (resource) => {
  if (!resource) return null;
  const direct = getReportUpdatedDate(
    resource.latest_resource_report ||
      resource.latest_report ||
      resource.latest_resource_estimate ||
      resource.latest_resource_estimate_report ||
      resource.production_report ||
      resource.latest_production_report
  );
  if (direct) return direct;
  return getLatestReportDate(
    resource.resource_reports ||
      resource.reports ||
      resource.resource_estimates ||
      resource.resource_estimate_reports ||
      resource.production_reports ||
      []
  );
};

export const getResourceSourceReport = (resource) =>
  resource?.latest_resource_report ||
  resource?.latest_report ||
  resource?.latest_resource_estimate ||
  resource?.latest_resource_estimate_report ||
  resource?.production_report ||
  resource?.latest_production_report ||
  resource?.resource_reports?.[0] ||
  resource?.reports?.[0] ||
  resource?.resource_estimates?.[0] ||
  resource?.resource_estimate_reports?.[0] ||
  resource?.production_reports?.[0] ||
  null;

export const formatMiningMethod = (value) => {
  if (!value) return "—";
  const normalized = `${value}`.toLowerCase();
  if (normalized === "both") return "Surface & Underground";
  if (normalized === "open_pit") return "Surface / Open Pit";
  if (normalized === "stockpile") return "Stockpile";
  if (normalized === "other") return "Other";
  return value;
};


